import CircularProgress from '@mui/material/CircularProgress';
import { Loading } from './styled';
type PageLoadingProps = {
  sx?: object;
};
const PageLoading = ({ sx }: PageLoadingProps) => {
  return (
    <Loading sx={sx}>
      <CircularProgress sx={{ color: 'brand.darkGreen' }} />
    </Loading>
  );
};

export default PageLoading;
